import Vue from "vue";
import Vuex from "vuex";

import managedata from "../helpers/managedata";
import params from "../helpers/params";
import utils from "../helpers/utils";
import navbarPermissions from "../helpers/navbarPermissions";

Vue.use(Vuex);

const START_REQUEST = "START_REQUEST";
const FINISH_REQUEST = "FINISH_REQUEST";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_ERROR = "LOGIN_ERROR";
const LOGIN_FAILED = "LOGIN_FAILED";
const LOGOUT = "LOGOUT";
const SET_ROUTE = "SET_ROUTE";
const SET_USER = "SET_USER";
const SET_ROLE = "SET_ROLE";
const CHANGE_ROUTE = "CHANGE_ROUTE";
const CLEAR_MESSAGE = "CLEAR_MESSAGE";
const CLEAR_ERROR_DIALOG_MESSAGE = "CLEAR_ERROR_DIALOG_MESSAGE";
const SET_ACTIVE_LINK = "SET_ACTIVE_LINK";
const SET_MESSAGE = "SET_MESSAGE";
const SET_APPS = "SET_APPS";
const SET_GROUPED_APPS = "SET_GROUPED_APPS";
const SET_SELECTED_CATEGORIES = "SET_SELECTED_CATEGORIES";
const SET_CATEGORIES = "SET_CATEGORIES";
const SET_ASSIGNMENTS = "SET_ASSIGNMENTS";
const SET_ALLOWED_ORG_AND_ALGORITHMS = "SET_ALLOWED_ORG_AND_ALGORITHMS";
const SET_USER_STATUSES = "SET_USER_STATUSES";
const SET_USERS = "SET_USERS";
const SET_ROLES = "SET_ROLES";
const SET_ORGANIZATIONS = "SET_ORGANIZATIONS";
const SET_TEAMS = "SET_TEAMS";
const SET_TEAMSASSIGNED = "SET_TEAMSASSIGNED";
const SET_IS_ADMIN = "SET_IS_ADMIN";
const SET_ORGANIZATION_ASSIGNMENT = "SET_ORGANIZATION_ASSIGNMENT";
const LOGIN_FAILED_PERMISSION_DENIED = "LOGIN_FAILED_PERMISSION_DENIED";
const SET_AUDIENCES = "SET_AUDIENCES";
const SET_PROTOCOLS = "SET_PROTOCOLS";
const SET_INVOCATION_TYPES = "SET_INVOCATION_TYPES";
const SET_PLATFORMS = "SET_PLATFORMS";
const SET_REGIONS_FOR_PLATFORMS = "SET_REGIONS_FOR_PLATFORMS";
const SET_CUSTOM_API_URL = "SET_CUSTOM_API_URL";
const SET_USERS_TEAM_ASSIGNMENTS = "SET_USERS_TEAM_ASSIGNMENTS";
const SET_USERID = "SET_USERID";

const strict = process.env.NODE_ENV !== "production";

const getters = {
  WBToken: (state) => state.WBToken,
  userId: (state) => state.userId,
  user: (state) => state.user,
  role: (state) => state.role,
  message: (state) => state.message,
  messageRandom: (state) => state.messageRandom,
  dialogErrorMessage: (state) => state.dialogErrorMessage,
  dialogErrorMessageRandom: (state) => state.dialogErrorMessageRandom,
  dialogErrorCode: (state) => state.dialogErrorCode,
  pending: (state) => state.pending,
  route: (state) => state.route,
  isLoggedIn: (state) => state.isLoggedIn,
  navbarItems: (state) => {
    return state.navbarItems
      .concat(state.forecastItems)
      .filter((item) =>
        navbarPermissions[item.access]
          ? navbarPermissions[item.access](state)
          : false
      );
  },
  profileMenuItems: (state) => {
    if (state.isAdmin) {
      if (!utils.isQuinyx()) {
        return state.profileMenuItems;
      } else {
        return state.profileMenuItems.filter((item) => item.url !== "/logout");
      }
    } else {
      if (!utils.isQuinyx()) {
        return state.profileMenuItems.filter((item) => item.url !== "/admin");
      } else {
        return state.profileMenuItems.filter((item) => {
          return item.url !== "/admin" && item.url !== "/logout";
        });
      }
    }
  },
  apps: (state) => state.apps,
  groupedApps: (state) => state.groupedApps,
  selectedCategories: (state) => state.selectedCategories,
  categories: (state) => state.categories,
  assignments: (state) => state.assignments,
  userStatuses: (state) => state.userStatuses,
  users: (state) => state.users,
  roles: (state) => state.roles,
  organizations: (state) => state.organizations,
  teams: (state) => state.teams,
  teamsAssigned: (state) => state.teamsAssigned,
  organizationAssignments: (state) => state.organizationAssignments,
  isAdmin: (state) => state.isAdmin,
  audiences: (state) => state.audiences,
  protocols: (state) => state.protocols,
  invocationTypes: (state) => state.invocationTypes,
  platforms: (state) => state.platforms,
  regionsForPlatforms: (state) => state.regionsForPlatforms,
  userTeamAssignments: (state) => state.userTeamAssignments,
};

const actions = {
  setupToken({ commit }, creds) {
    commit(START_REQUEST);
    const neededRoute = this.state.navbarItems.find(
      (item) => item.url === "/portal"
    );

    commit({
      type: LOGIN_SUCCESS,
      response: creds.body,
      remember: creds.remember,
    });

    if (neededRoute && !creds.isExternal) {
      commit({
        type: CHANGE_ROUTE,
        item: neededRoute,
      });
    }

    commit(FINISH_REQUEST);
  },
  setCustomApiUrl({ commit }, customApiUrl) {
    commit({ type: SET_CUSTOM_API_URL, url: customApiUrl });
  },
  login({ commit }, creds) {
    commit(START_REQUEST);

    return new Promise((resolve, reject) => {
      managedata
        .login(creds.user, this.state.customApiUrl)
        .then((res) => {
          const neededRoute = this.state.navbarItems.find(
            (item) => item.url === "/portal"
          );

          commit({
            type: LOGIN_SUCCESS,
            response: res.body,
            remember: creds.remember,
          });

          if (neededRoute && !creds.isExternal) {
            commit({
              type: CHANGE_ROUTE,
              item: neededRoute,
            });
          }

          commit(FINISH_REQUEST);
          resolve();
        })
        .catch((err) => {
          try {
            const error = JSON.parse(err.bodyText);
            if (
              error.error.statusCode === 403 &&
              error.error.code === "LOGIN_FAILED_PERMISSION_DENIED"
            ) {
              commit({
                type: LOGIN_FAILED_PERMISSION_DENIED,
                message:
                  "Unfortunately, you are not authorised to access this application. Please contact application manager in your company or Widget Brain Support.",
                errorCode: error.error.statusCode,
              });
            } else if (error.error.statusCode === 401) {
              commit({
                type: LOGIN_FAILED,
                message:
                  "Incorrect username and/or password. Please check your credentials.",
                errorCode: error.error.statusCode,
              });
            } else {
              commit({
                type: LOGIN_ERROR,
                response: err,
              });
            }
          } catch (e) {
            commit({
              type: LOGIN_ERROR,
              response: err,
            });
          }
          commit(FINISH_REQUEST);
          console.log(err);
          reject(err);
        });
    });
  },
  logout({ commit }) {
    commit(LOGOUT);
  },
  forgotPassword({ commit }, email) {
    if (!email) {
      commit({
        type: SET_MESSAGE,
        message: "Email not sent, fill the email field.",
      });
      return false;
    }
    commit(START_REQUEST);
    managedata
      .forgotPassword(email, this.state.customApiUrl)
      .then((res) => {
        const message = `An email has been sent to ${email}`;
        commit({
          type: SET_MESSAGE,
          message,
        });
        commit(FINISH_REQUEST);
      })
      .catch((err) => {
        console.log(err);
        commit(FINISH_REQUEST);
      });
  },
  resetPassword({ commit }, payload) {
    commit(START_REQUEST);
    managedata
      .resetPassword(payload.pw, payload.token, this.state.customApiUrl)
      .then((res) => {
        const message = `Password has been changed`;
        commit({
          type: SET_MESSAGE,
          message,
        });
        commit({
          type: SET_ROUTE,
          route: "login",
        });
        commit(FINISH_REQUEST);
      })
      .catch((err) => {
        console.log(err);
        commit(FINISH_REQUEST);
      });
  },
  changePassword({ commit }, payload) {
    // payload: { oldPassword, newPassword }
    commit(START_REQUEST);
    console.log("here");
    return new Promise((resolve, reject) => {
      managedata
        .changePassword(
          payload.userId,
          payload.oldPassword,
          payload.newPassword,
          this.state.customApiUrl
        )
        .then((res) => {
          commit({
            type: SET_MESSAGE,
            message: `Password has been changed`,
          });
          commit(LOGOUT);
          commit({
            type: SET_ROUTE,
            route: "login",
          });
          commit(FINISH_REQUEST);
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject(err);
        });
    });
  },
  getUser({ commit, state }) {
    const userId = state.userId || localStorage.getItem("userId");
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getUser(userId)
        .then((res) => {
          const assignmentId = res.body.appAssignments.findIndex(
            (assignment) =>
              assignment.appId == params.getParameterValue("APP_ID")
          );

          if (assignmentId < 0) {
            commit(LOGOUT);
            console.log(res.body.appAssignments[assignmentId].role);
          } else {
            commit({
              type: SET_ROLE,
              role: res.body.appAssignments[assignmentId].role,
            });
            console.log(res.body.appAssignments[assignmentId]);
            if (
              res.body.appAssignments[assignmentId].role &&
              res.body.appAssignments[assignmentId].role.toLowerCase() ===
                "admin"
            ) {
              commit({
                type: SET_IS_ADMIN,
                isAdmin: true,
              });
            }
          }
          commit({
            type: SET_USER,
            user: res.body,
          });

          commit(FINISH_REQUEST);
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject(err);
        });
    });
  },
  getValidateToken({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .validateToken()
        .then((res) => {
          const data = res.body;
          commit({
            type: SET_USERID,
            data,
          });
          resolve(res.body);
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject(err);
        });
    });
  },
  changeRoute({ commit }, item) {
    commit({
      type: CHANGE_ROUTE,
      item,
    });
  },
  getApps({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getApps()
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_APPS,
            apps: res.body,
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  getGroupedApps({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getGroupedApps()
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_GROUPED_APPS,
            apps: res.body,
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  getUserTeamAssignments({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getUserTeamAssignments()
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_USERS_TEAM_ASSIGNMENTS,
            userTeam: res.body,
          });
          resolve(res.body);
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  createUserTeamAssignments({ commit }, data) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .createUserTeamAssignments(data)
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "User successfully created",
          });
          resolve(res.body);
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  updateUserTeamAssignments({ commit, dispatch }, data) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .updateUserTeamAssignments(data)
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "User team assignment updated",
          });
          dispatch("getAssignedTeams")
            .then(() => resolve())
            .catch((err) => reject(err));
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject(err);
        });
    });
  },
  deleteUserTeamAssignments({ commit }, id) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .deleteUserTeamAssignments(id)
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "User deleted",
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  getAssignments({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getAssignments()
        .then((res) => {
          const s = store.state;
          const assignments = res.body.result;
          const filteredCategories = [];
          const apps = s.groupedApps
            ? s.groupedApps.reduce((acc, cur) => {
                if (cur.apps && cur.apps.length) return acc.concat(cur.apps);
                acc.push(cur);
                return acc;
              }, [])
            : s.apps;
          assignments.forEach((assignment) => {
            const appIndex = apps.findIndex(
              (app) => app.id == assignment.appId
            );
            if (appIndex !== -1) {
              const app = apps[appIndex];
              if (
                filteredCategories.findIndex((cat) => cat == app.Category) ==
                  -1 &&
                app.Category &&
                app.Category !== "Admin" &&
                app.Category.length > 0 &&
                app.url
              ) {
                filteredCategories.push(app.Category);
              }
              if (
                app.Name === "Admin" &&
                assignment.role &&
                assignment.role.toLowerCase() === "admin"
              ) {
                commit({
                  type: SET_IS_ADMIN,
                  isAdmin: true,
                });
              }
            }
          });
          commit({
            type: SET_SELECTED_CATEGORIES,
            selectedCategories: filteredCategories,
          });
          commit({
            type: SET_CATEGORIES,
            categories: filteredCategories,
          });
          commit(FINISH_REQUEST);
          commit({
            type: SET_ASSIGNMENTS,
            assignments: res.body.result,
          });

          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  getUserStatuses({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getUserStatuses()
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_USER_STATUSES,
            userStatuses: res.body,
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  getUsers({ commit, state }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getUsers()
        .then((res) => {
          const users = res.body;
          const usersWithStatuses = users.map((user) => {
            const newUser = Object.assign({}, user);
            if (state.userStatuses && state.userStatuses[newUser.id])
              newUser.status = state.userStatuses[newUser.id];
            return newUser;
          });
          commit(FINISH_REQUEST);
          commit({
            type: SET_USERS,
            users: usersWithStatuses,
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  createUserFromApp({ commit, state }, payload) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      if (!utils.isQuinyx()) {
        managedata
          .createUserFromApp(payload.user)
          .then((res) => {
            if (!res.body.message) {
              commit({
                type: SET_MESSAGE,
                message: "New user added",
              });
            }
            commit(FINISH_REQUEST);
            resolve(res);
          })
          .catch((err) => {
            console.log(err);
            commit(FINISH_REQUEST);
            reject(err);
          });
      } else {
        managedata
          .createUserFromQuinyxApp(payload.user)
          .then((res) => {
            if (!res.body.message) {
              commit({
                type: SET_MESSAGE,
                message: "New user added",
              });
            }
            commit(FINISH_REQUEST);
            resolve(res);
          })
          .catch((err) => {
            console.log(err);
            commit(FINISH_REQUEST);
            reject(err);
          });
      }
    });
  },
  updateUser({ commit, dispatch }, user) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .updateUser(user)
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "User updated",
          });
          dispatch("getUser")
            .then(() => resolve())
            .catch((err) => reject(err));
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject(err);
        });
    });
  },
  updateUserTeams({ commit, dispatch }, data) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .updateUserTeams(data)
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "User team list updated",
          });
          dispatch("getUser")
            .then(() => resolve())
            .catch((err) => reject(err));
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject(err);
        });
    });
  },
  updateTeamsAssignment({ commit, dispatch }, data) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .updateTeamsAssignment(data)
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "Team assignment updated",
          });
          dispatch("getAssignedTeams")
            .then(() => resolve())
            .catch((err) => reject(err));
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject(err);
        });
    });
  },
  deleteUser({ commit }, user) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .deleteUser(user.id)
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "User deleted",
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  deleteUserTeam({ commit }, data) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .deleteUserTeam(data)
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "User unassigned",
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  deleteFromParentTeam({ commit }, data) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .deleteFromParentTeam(data)
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "User team list updated",
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject(err);
        });
    });
  },
  getRolesById({ commit }, payload) {
    commit(START_REQUEST);
    const data = (payload && payload.id) || null;
    return new Promise((resolve, reject) => {
      managedata
        .getRoles(data)
        .then((res) => {
          commit({
            type: SET_ROLES,
            roles: res.body,
          });
          commit(FINISH_REQUEST);
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  createApp({ commit }, app) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .createApp(app)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "App added",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  updateApp({ commit }, app) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .updateApp(app)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "App updated",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  deleteApp({ commit }, app) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .deleteApp(app)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "App deleted",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  getRoles({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getRoles()
        .then((res) => {
          commit({
            type: SET_ROLES,
            roles: res.body,
          });
          commit(FINISH_REQUEST);
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  createRole({ commit }, role) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .createRole(role)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "Role added",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          resolve();
        });
    });
  },
  updateRole({ commit }, role) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .updateRole(role)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "Role updated",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  deleteRole({ commit }, role) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .deleteRole(role)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "Role deleted",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  getOrganizations({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getOrganizations()
        .then((res) => {
          commit({
            type: SET_ORGANIZATIONS,
            organizations: res.body,
          });
          commit(FINISH_REQUEST);
          resolve(res.body);
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject(err);
        });
    });
  },
  getTeams({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getTeams()
        .then((res) => {
          commit({
            type: SET_TEAMS,
            teams: res.body,
          });
          commit(FINISH_REQUEST);
          resolve(res.body);
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject(err);
        });
    });
  },
  getTeamById({ commit }, teamId) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getTeamById(teamId)
        .then((res) => {
          commit(FINISH_REQUEST);
          resolve(res.body);
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject(err);
        });
    });
  },
  getAssignedTeams({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getAssignedTeams()
        .then((res) => {
          commit({
            type: SET_TEAMSASSIGNED,
            teamsAssigned: res.body,
          });
          commit(FINISH_REQUEST);
          resolve(res.body);
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject(err);
        });
    });
  },
  createOrganization({ commit }, organization) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .createOrganization(organization)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "Organization added",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  updateOrganization({ commit }, organization) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .updateOrganization(organization)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "Organization updated",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  deleteOrganization({ commit }, organization) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .deleteOrganization(organization)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "Organization deleted",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  getOrganizationAssignments({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getOrganizationAssignments()
        .then((res) => {
          commit({
            type: SET_ORGANIZATION_ASSIGNMENT,
            organizationAssignments: res.body,
          });
          commit(FINISH_REQUEST);
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  createOrganizationAssignment({ commit }, organizationAssignment) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .createOrganizationAssignment(organizationAssignment)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "Organization assignment added",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  updateOrganizationAssignment({ commit }, organizationAssignment) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .updateOrganizationAssignment(organizationAssignment)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "Organization assignment updated",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  deleteOrganizationAssignment({ commit }, organizationAssignment) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .deleteOrganizationAssignment(organizationAssignment)
        .then(() => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_MESSAGE,
            message: "Organization assignment deleted",
          });
          resolve();
        })
        .catch((err) => {
          console.log(err);
          commit(FINISH_REQUEST);
          reject();
        });
    });
  },
  getAudiences({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getAudiences()
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_AUDIENCES,
            audiences: res.body,
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  getProtocols({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getProtocols()
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_PROTOCOLS,
            protocols: res.body,
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  getInvocationTypes({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getInvocationTypes()
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_INVOCATION_TYPES,
            invocationTypes: res.body,
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  getPlatforms({ commit }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getPlatforms()
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_PLATFORMS,
            platforms: res.body,
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  getRegionsForPlatform({ commit }, platformTag) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .getRegionsForPlatform(platformTag)
        .then((res) => {
          commit(FINISH_REQUEST);
          commit({
            type: SET_REGIONS_FOR_PLATFORMS,
            regionsForPlatforms: res.body,
          });
          resolve();
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          console.log(err);
          reject();
        });
    });
  },
  getOrganisationsById({ commit }, data) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      let promises = data.map((e) => {
        return managedata.getOrganisationById(e.organisationId).then((org) => {
          e.organizationName = org.body.name;
          return e;
        });
      });

      Promise.all(promises)
        .then((res) => {
          commit(FINISH_REQUEST);
          resolve(res);
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          reject(err);
        });
    });
  },
  resetAuth0Credentials({ commit, state }) {
    commit(START_REQUEST);
    return new Promise((resolve, reject) => {
      managedata
        .resetAuth0Credentials(state.user.id)
        .then((resp) => {
          commit({
            type: SET_MESSAGE,
            message: "Credentials resetted!",
          });
          commit(FINISH_REQUEST);
          resolve(resp);
        })
        .catch((err) => {
          commit(FINISH_REQUEST);
          reject(err);
        });
    });
  },
};

const mutations = {
  [START_REQUEST](state) {
    state.pending = true;
  },
  [FINISH_REQUEST](state) {
    state.pending = false;
  },
  [LOGOUT](state) {
    const exec = {
      message: {
        type: SET_MESSAGE,
        message: "You logged out",
      },
    };
    managedata
      .logout(this.state.customApiUrl)
      .then(() => {
        localStorage.removeItem("WBToken");
        localStorage.removeItem("userId");
        let initialState = getInitialState();
        state = Object.assign(state, initialState);
        this.commit(exec.message);
      })
      .catch((err) => {
        localStorage.removeItem("WBToken");
        localStorage.removeItem("userId");
        let initialState = getInitialState();
        state = Object.assign(state, initialState);
        this.commit(exec.message);
      });
  },
  [SET_USERID](state, { data }) {
    if (data.userId) {
      state.userId = data.userId;
    }
  },
  [LOGIN_SUCCESS](state, payload) {
    this.commit(CLEAR_MESSAGE);
    state.isLoggedIn = true;
    state.WBToken = payload.response.id;
    state.userId = payload.response.userId;

    if (payload.remember) {
      localStorage.setItem("WBToken", state.WBToken);
      localStorage.setItem("userId", state.userId);
    }
    state.message = "Login succesful. Welcome back!";
  },
  [LOGIN_ERROR](state, payload) {
    this.commit(CLEAR_ERROR_DIALOG_MESSAGE);
    state.dialogErrorMessage =
      "Oops… seems like you cannot access your application right now.";
    state.dialogErrorCode = 500;
  },
  [LOGIN_FAILED](state, payload) {
    this.commit(CLEAR_ERROR_DIALOG_MESSAGE);
    state.dialogErrorMessage = payload.message;
    state.dialogErrorCode = payload.errorCode;
  },
  [LOGIN_FAILED_PERMISSION_DENIED](state, payload) {
    this.commit(CLEAR_ERROR_DIALOG_MESSAGE);
    state.dialogErrorMessage = payload.message;
    state.dialogErrorCode = payload.errorCode;
  },
  [SET_ROUTE](state, payload) {
    state.route = payload.route;
  },
  [SET_USER](state, payload) {
    state.user = payload.user;
  },
  [SET_ROLE](state, payload) {
    state.role = payload.role;
  },
  [CHANGE_ROUTE](state, payload) {
    state.route = payload.item.url;
  },
  [CLEAR_MESSAGE](state) {
    state.messageRandom = Math.random();
    state.message = null;
  },
  [CLEAR_ERROR_DIALOG_MESSAGE](state) {
    state.dialogErrorMessageRandom = Math.random();
    state.dialogErrorMessage = null;
    state.dialogErrorCode = null;
  },
  [SET_MESSAGE](state, payload) {
    this.commit(CLEAR_MESSAGE);
    state.message = payload.message;
  },
  [SET_ACTIVE_LINK](state, payload) {
    const currentItem = payload.currentItem;
    if (currentItem) {
      state.navbarItems.forEach((item) => {
        if (currentItem.id === item.id) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
      state.forecastItems.forEach((item) => {
        if (currentItem.id === item.id) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
    } else {
      state.navbarItems.forEach((item) => {
        item.active = false;
      });
    }
  },
  [SET_GROUPED_APPS](state, payload) {
    state.groupedApps = payload.apps;
  },
  [SET_USERS_TEAM_ASSIGNMENTS](state, payload) {
    state.userTeamAssignments = payload.userTeam;
  },
  [SET_APPS](state, payload) {
    state.apps = payload.apps;
  },
  [SET_SELECTED_CATEGORIES](state, payload) {
    state.selectedCategories = payload.selectedCategories;
  },
  [SET_CATEGORIES](state, payload) {
    state.categories = payload.categories;
  },
  [SET_ASSIGNMENTS](state, payload) {
    state.assignments = payload.assignments;
  },
  [SET_ALLOWED_ORG_AND_ALGORITHMS](state, payload) {
    state.allowedOrganizationsAndAlgorithms =
      payload.allowedOrganizationsAndAlgorithms;
  },

  [SET_USER_STATUSES](state, payload) {
    state.userStatuses = payload.userStatuses;
  },
  [SET_USERS](state, payload) {
    state.users = payload.users;
  },
  [SET_ROLES](state, payload) {
    state.roles = payload.roles;
  },
  [SET_ORGANIZATIONS](state, payload) {
    state.organizations = payload.organizations;
  },
  [SET_TEAMS](state, payload) {
    state.teams = payload.teams;
  },
  [SET_TEAMSASSIGNED](state, payload) {
    state.teamsAssigned = payload.teamsAssigned;
  },
  [SET_ORGANIZATION_ASSIGNMENT](state, payload) {
    state.organizationAssignments = payload.organizationAssignments;
  },
  [SET_IS_ADMIN](state, payload) {
    state.isAdmin = payload.isAdmin;
  },
  [SET_AUDIENCES](state, payload) {
    state.audiences = payload.audiences;
  },
  [SET_PROTOCOLS](state, payload) {
    state.protocols = payload.protocols;
  },
  [SET_INVOCATION_TYPES](state, payload) {
    state.invocationTypes = payload.invocationTypes;
  },
  [SET_PLATFORMS](state, payload) {
    state.platforms = payload.platforms;
  },
  [SET_REGIONS_FOR_PLATFORMS](state, payload) {
    state.regionsForPlatforms = payload.regionsForPlatforms;
  },
  [SET_CUSTOM_API_URL](state, payload) {
    state.customApiUrl = payload.url;
  },
};

function getInitialState() {
  return {
    isLoggedIn: !!localStorage.getItem("WBToken") || utils.isQuinyx(),
    pending: false,
    WBToken: null,
    userId: null,
    user: null,
    role: null,
    message: null,
    messageRandom: null,
    dialogErrorMessage: null,
    dialogErrorMessageRandom: null,
    dialogErrorCode: null,
    route: null,
    apps: null,
    selectedCategories: [],
    categories: [],
    assignments: null,
    allowedOrganizationsAndAlgorithms: null,
    userStatuses: null,
    users: null,
    roles: null,
    organizations: null,
    teams: null,
    teamsAssigned: null,
    organizationAssignments: null,
    isAdmin: false,
    verticals: [
      { name: "Logistics", show: true },
      { name: "Equipment", show: true },
      { name: "Industry", show: true },
      { name: "Admin", show: true },
    ],
    navbarItems: [
      {
        id: 0,
        name: "Applications",
        url: "/portal",
        onClick() {
          store.dispatch("changeRoute", this);
        },
        active: false,
        access: "application",
      },
    ],
    forecastItems: [
      /*{
                id: 6,
                name: 'Raw data',
                url: '/rawdata',
                onClick() {
                    store.dispatch('changeRoute', this)
                },
                active: false,
                access: 'forecast',
            },
            {
                id: 7,
                name: 'Forecast',
                url: '/forecast',
                onClick() {
                    store.dispatch('changeRoute', this)
                },
                active: false,
                access: 'forecast',
            },*/
    ],
    profileMenuItems: [
      {
        icon: "admin",
        name: "Admin",
        url: "/admin",
        onClick() {
          store.dispatch("changeRoute", this);
        },
      },
      {
        icon: "",
        name: "My account",
        url: "/my-account",
        onClick() {
          store.dispatch("changeRoute", this);
        },
      },
      {
        icon: "",
        name: "Help",
        onClick() {
          window.location.href = "https://docs.widgetbrain.io/portal";
        },
      },
      {
        icon: "logout",
        name: "Log out",
        url: "/logout",
        onClick() {
          store.dispatch("logout");
        },
      },
    ],
    audiences: [],
    protocols: [],
    invocationTypes: [],
    platforms: [],
    regionsForPlatforms: [],
    services: [],
    apps: [],
    groupedApps: [],
    userTeamAssignments: [],
    customApiUrl: null,
  };
}

const state = getInitialState();

export const store = new Vuex.Store({
  strict,
  state,
  mutations,
  getters,
  actions,
});



// WEBPACK FOOTER //
// ./src/store/store.js